import API from './index';

export const clientsAPI = {
  getAll: (params) => API.get('/clients', { params }),
  getById: (id) => API.get(`/clients/${id}`),
  getStats: () => API.get('/clients/stats'),
  create: (client) => API.post('/clients', client),
  update: (id, client) => API.put(`/clients/${id}`, client),
  delete: (id) => API.delete(`/clients/${id}`),
  addNote: (id, note) => API.post(`/clients/${id}/notes`, note)
};